/** Steam's logo — lucide-react carries no brand icons (see DiscordIcon). */
export default function SteamIcon({ size = 18 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M11.98 2C6.65 2 2.28 6.11 1.87 11.33l5.37 2.22a3.03 3.03 0 0 1 1.71-.53l2.39-3.46v-.05a4.04 4.04 0 1 1 4.04 4.04h-.1l-3.41 2.43v.15a3.04 3.04 0 0 1-6.02.6L2 14.99A10.02 10.02 0 0 0 11.98 22 10 10 0 0 0 22 12 10 10 0 0 0 11.98 2zM8.16 17.17l-1.24-.51a2.28 2.28 0 0 0 3.1.99 2.28 2.28 0 0 0-.72-4.25 2.28 2.28 0 0 0-1.32.12l1.28.53a1.68 1.68 0 0 1-1.1 3.12zm10.5-7.66a2.7 2.7 0 1 0-5.39 0 2.7 2.7 0 0 0 5.39 0zm-4.72 0a2.03 2.03 0 1 1 4.05 0 2.03 2.03 0 0 1-4.05 0z" />
    </svg>
  )
}
